import { useCallback } from 'react'

import { useAtomValue, useSetAtom } from 'jotai'

import { automationNameAtom } from 'Automations/automationEditor/atoms'
import type { StartNodeTrigger } from 'Automations/nodeDefinitions/definitions/start'
import { startNodeTriggerLabel } from 'Automations/nodeDefinitions/definitions/start'

export const useSetDefaultAutomationName = () => {
  const automationName = useAtomValue(automationNameAtom)
  const setAutomationName = useSetAtom(automationNameAtom)

  const setDefaultAutomationName = useCallback(
    (trigger: StartNodeTrigger) => {
      const triggerDefaultNames = new Set(Object.values(startNodeTriggerLabel))
      const isDefaultName =
        automationName === '' || triggerDefaultNames.has(automationName)

      if (isDefaultName) {
        setAutomationName(startNodeTriggerLabel[trigger])
      }
    },
    [automationName, setAutomationName]
  )

  return { setDefaultAutomationName }
}
